
import { Button } from "@/components/ui/button";
import { useRef } from "react";

const Hero = () => {
  const cardRef = useRef<HTMLDivElement>(null);
  const handleMove = (e: React.MouseEvent) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty("--mx", `${x}px`);
    card.style.setProperty("--my", `${y}px`);
  };
  return <section id="home" aria-label="Hero" className="relative">
      <div className="min-h-[70vh] md:min-h-[85vh] bg-cover bg-center" style={{
      backgroundImage: `url(/lovable-uploads/38764b79-2359-498d-9218-eaee5e758285.png)`
    }}>
        <div className="container mx-auto flex items-center justify-center py-16 md:py-24">
          <div ref={cardRef} onMouseMove={handleMove} className="relative w-full max-w-4xl rounded-2xl bg-primary text-primary-foreground shadow-2xl p-8 md:p-12">
            <div aria-hidden className="pointer-events-none absolute inset-0 rounded-2xl" style={{
            background: "radial-gradient(640px circle at var(--mx,50%) var(--my,50%), hsl(var(--primary-glow) / 0.32), hsl(var(--accent) / 0.16), transparent 46%)"
          }} />
            <div className="relative grid md:grid-cols-3 gap-6 md:gap-10 items-center">
              <div className="md:col-span-2">
                <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                  Automate Your Business Now
                </h1>
                <p className="text-lg md:text-xl text-primary-foreground/90 mb-6">
                  AI Montclair specializes in AI powered solutions to optimize your business operations and cut down on mundane tasks, enhancing productivity and profit.
                </p>
                <Button variant="hero" size="lg" asChild>
                  <a href="#contact">Book a Free Consultation</a>
                </Button>
              </div>
              <div className="md:col-span-1">
                <img src="/lovable-uploads/768b2d45-ff22-404c-8109-399db842292a.png" alt="Team collaborating in a bright office" loading="lazy" className="w-full h-48 md:h-56 object-cover rounded-xl ring-1 ring-primary/20 shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;
